import { ReactNode } from 'react';

import { ExternalLinkIcon } from 'lucide-react';

import { TruncatedText } from '@/components/atoms/TruncatedText/TruncatedText';
import { WarningAlert } from '@/components/atoms/WarningAlert/WarningAlert';

interface Reference {
  [key: string]: unknown;
}

interface Props<T extends Reference> {
  children: ReactNode;
  references: T[];
  onRefClick: (key: string) => void;
  referenceProp?: string;
  labelKey?: string;
}

export function AlertWithReferences<T extends Reference>({
  children,
  references,
  onRefClick,
  referenceProp = 'dialogId',
  labelKey = 'label',
}: Props<T>) {
  return (
    <WarningAlert>
      <p>{children}</p>
      <div className="flex max-h-60 flex-wrap gap-x-4 gap-y-1 overflow-y-auto text-primary">
        {references.map((reference, i) => (
          <button
            // eslint-disable-next-line react/no-array-index-key
            key={`${String(reference[labelKey])}_${i}`}
            type="button"
            onClick={() => onRefClick(reference[referenceProp] as string)}
            className="inline-flex max-w-60 items-center gap-1 bg-transparent text-left text-inherit underline"
          >
            <TruncatedText text={String(reference[labelKey])} size="large" />
            <ExternalLinkIcon size={16} className="shrink-0 text-muted-foreground" />
          </button>
        ))}
      </div>
    </WarningAlert>
  );
}
